import { Component, Inject } from '@angular/core';
import { Message } from '../../http/message';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
    selector: 'app-custom-snackbar',
    templateUrl: './custom-snackbar.component.html',
    styleUrl: './custom-snackbar.component.scss',
    standalone: true,
    imports: [MatIconModule],
})

export class CustomSnackBarComponent {

    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: Message, public snackBarRef: MatSnackBarRef<CustomSnackBarComponent>) {
            this.snackBarRef._dismissAfter(data.Duration);
    }

    public dismiss() {
        this.snackBarRef.dismiss();
    }
}
